import React from "react";
import Headers from "../../../components/Headers";
import { Form } from "antd";
import Zhifubao from "../components/Zhifubao";
import Weixin from "../components/Weixin";
import { fetchAccountInfo } from "../../../api/capitalAccount";
import NProgress from "nprogress";

const BreadCrumbData = [
  { path: "/page/capitalaccount", name: "收支账户管理" },
  { path: "/page/capitalaccount/cashAccount", name: "收银账户" },
];

class EarningsAccount extends React.Component {
  state = {
    isEdit1: false,
    isEdit2: false,
    data: {},
  };
  async componentDidMount() {
    NProgress.start();
    await this.getAccountInfo();
    NProgress.done();
  }
  getAccountInfo = () => {
    fetchAccountInfo().then((res) => {
      this.setState({
        data: res.data,
      });
    });
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
      }
    });
  };
  setZhifubao = () => this.setState({ isEdit1: true });
  cancelZhifubao = () => this.setState({ isEdit1: false });
  setWeixin = () => this.setState({ isEdit2: true });
  cancelWeixin = () => this.setState({ isEdit2: false });
  render() {
    const { isEdit1, isEdit2, data } = this.state;

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>

        <Zhifubao
          setZhifubao={this.setZhifubao}
          cancelZhifubao={this.cancelZhifubao}
          getAccountInfo={this.getAccountInfo}
          isEdit1={isEdit1}
          aliPay={data.aliPayPA}
        ></Zhifubao>
        <Weixin
          setWeixin={this.setWeixin}
          cancelWeixin={this.cancelWeixin}
          getAccountInfo={this.getAccountInfo}
          isEdit2={isEdit2}
          weChat={data.weChatPA}
        ></Weixin>
      </div>
    );
  }
}
export default Form.create()(EarningsAccount);
